// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntable[data-v-22a1e4a2] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntbody tr[data-v-22a1e4a2]:nth-child(even) {\n  backdrop-filter: brightness(90%);\n}\ntd.name[data-v-22a1e4a2] {\n  width: 10%;\n  border-right: 1px solid lightgray;\n  padding-left: 0;\n  padding-right: 1em;\n  font-weight: bold;\n}\ntd[data-v-22a1e4a2] {\n  padding-left: 1em;\n}\ntd.from[data-v-22a1e4a2] {\n  width: 45%;\n  border-right: 1px solid lightgray;\n}\n", ""]);
// Exports
module.exports = exports;
